import { mount } from "@vue/test-utils";
import ProgressBar from "@/components/core/ProgressBar";

describe("ProgressBar component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(ProgressBar, {
      propsData: {
        percentage: 5
      }
    });
  });

  it("Renders del component ProgressBar", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
